import { render } from "./import_v1.vue?vue&type=template&id=54c2cdfa"
import script from "./import_v1.vue?vue&type=script&lang=js"
export * from "./import_v1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__